"use client"
import { ActionIcon, Menu, Tooltip } from "@mantine/core"
import { useDebouncedState, useHover } from "@mantine/hooks"
import { useEffect } from "react"
import classes from "./NavbarButtonWithMenu.module.css"

interface NavbarButtonWithMenuProps {
  isSelected: boolean
  icon: any
  children: React.ReactNode
  label: string
}

export function NavbarButtonWithMenu({ isSelected, icon: Icon, children, label }: NavbarButtonWithMenuProps) {
  const { hovered, ref } = useHover()
  const [debouncedHovered, setDebouncedHovered] = useDebouncedState(false, 100)

  useEffect(() => {
    setDebouncedHovered(hovered)
  }, [hovered, setDebouncedHovered])

  return (
    <div className={classes.container} ref={ref}>
      <Menu trigger="hover" loop={false} withinPortal={false} trapFocus={false} menuItemTabIndex={0} position="right-start" withArrow zIndex={8001} shadow="lg">
        <Menu.Target>
          <Tooltip label={label} position="right" disabled={hovered || debouncedHovered}>
            <ActionIcon
              data-selected={isSelected}
              variant={isSelected ? "white" : "transparent"}
              color={isSelected ? "rBackBlue.9" : "gray.3"}
              size="lg"
              radius="md"
              className={classes.actionIcon}
              style={{
                zIndex: hovered || debouncedHovered ? 8001 : 10,
              }}
            >
              <Icon className={classes.icon} stroke={1.5} />
            </ActionIcon>
          </Tooltip>
        </Menu.Target>
        {children}
      </Menu>
    </div>
  )
}
